import { createReducer } from '../../utils';
import { CALL_API } from '../../store/middleware/api';

export const SET_OVERLAY = 'SET_OVERLAY';
export const UNSET_OVERLAY = 'UNSET_OVERLAY';
const FORM_VERSION_REQUEST = 'FORM_VERSION_REQUEST';
const FORM_VERSION_SUCCESS = 'FORM_VERSION_SUCCESS';
const FORM_VERSION_FAILURE = 'FORM_VERSION_FAILURE';
export function setOverlay(overlay) {
  return dispatch => {
    dispatch({
      type: SET_OVERLAY,
      payload: overlay
    });
  };
}

export function unsetOverlay(overlay) {
  return dispatch => {
    dispatch({
      type: UNSET_OVERLAY
    });
  };
}

const ACTION_HANDLERS = {
  [SET_OVERLAY]: (state, { payload }) => ({
    ...state,
    overlay: payload
  }),
  [UNSET_OVERLAY]: state => ({
    ...state,
    overlay: null
  }),
  [FORM_VERSION_SUCCESS]: (state, { payload }) => ({
    ...state,
    formSchemaVersion: payload.formSchemaVersion
  })
};

const initialState = {
  overlay: null,
  isNotificationsDropdownOpen: false,
  formSchemaVersion: -1
};

export function requestFormSchemaVersion() {
  return {
    [CALL_API]: {
      method: 'get',
      types: [FORM_VERSION_REQUEST, FORM_VERSION_SUCCESS, FORM_VERSION_FAILURE],
      endpoint: '/api/proposal/form/version'
    }
  };
}

export default createReducer(ACTION_HANDLERS, initialState);
